import { desktopBridge } from './desktop-bridge';
import { desktopPrintingApi } from './desktop-printing.api';
import { DesktopPrintingCapabilities } from './printing.types';

const CACHE_TTL_MS = 60_000;
let cached: { value: DesktopPrintingCapabilities; expiresAt: number } | undefined;

export const desktopCapabilities = {
  async get(forceRefresh = false): Promise<DesktopPrintingCapabilities> {
    if (!forceRefresh && cached && cached.expiresAt > Date.now()) {
      return cached.value;
    }
    const value = await desktopPrintingApi.getCapabilities();
    cached = { value, expiresAt: Date.now() + CACHE_TTL_MS };
    return value;
  },
  invalidate(): void {
    cached = undefined;
  },
};

desktopBridge.onReady(() => desktopCapabilities.invalidate());
